/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-video-mute-toggle]').forEach(function (btn) {
      var wrapper = document.querySelector('[data-video-id="' + btn.getAttribute('data-video-mute-toggle') + '"]');
      if (!wrapper) return;

      function updateIcon(video) {
        var mutedIcon = btn.querySelector('.icon-muted');
        var unmutedIcon = btn.querySelector('.icon-unmuted');
        mutedIcon.style.display = video.muted ? 'block' : 'none';
        unmutedIcon.style.display = video.muted ? 'none' : 'block';
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }

      function bindVideo(video) {
        updateIcon(video);
        btn.addEventListener('click', function () {
          video.muted = !video.muted;
          updateIcon(video);
        });
      }

      var existing = wrapper.querySelector('video');
      if (existing) {
        bindVideo(existing);
      } else {
        var observer = new MutationObserver(function () {
          var v = wrapper.querySelector('video');
          if (v) {
            bindVideo(v);
            observer.disconnect();
          }
        });
        observer.observe(wrapper, { childList: true, subtree: true });
      }
    });
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
